import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, tilesFeatureKey, TileStateKey } from './tile.reducer';

export const tileFeature = createFeatureSelector<State>(tilesFeatureKey);

export const getCallState = createSelector(tileFeature, (state) => {
   return state.callState;
});

export const getTiles = createSelector(tileFeature, (state) => {
   return state.tiles;
});

export const getTileLoadBatchQueue = createSelector(tileFeature, (state) => {
   return state.tileLoadBatchQueue;
});

export const getTile = (dashboardTileId: TileStateKey) =>
   createSelector(getTiles, (tiles) => {
      const x = tiles ? tiles[dashboardTileId] : undefined;
      return x;
   });

export const getTileData = (dashboardTileId: TileStateKey) =>
   createSelector(getTile(dashboardTileId), (tile) => {
      return tile ? tile.data : undefined;
   });

export const getTileCallState = (dashboardTileId: TileStateKey) =>
   createSelector(getTile(dashboardTileId), (tile) => {
      return tile ? tile.callState : undefined;
   });
